export default __webpack_public_path__ + "static/media/litehowplay.adbf653b.png";